<template>
    <div class="chart-filters" :class="{ open: filtersData.open }">
        <div class="filters-header">
            <h4 class="filters-title">
                <img src="../../assets/images/filters.svg" alt="Filters">
                Filters
            </h4>
            <a href="#" class="filters-close" @click="closeFilters">
                <svg class="ico" width="13px" height="13px">
                    <use xlink:href="#ico-close-big"></use>
                </svg>
            </a>

        </div>
        <div class="filters-divider"></div>
        <VueCustomScrollbar class="filters-content">
            <div class="filters-scroll-content">
                <div class="filters-chart-type">
                    <p class="filter-label">Chart Type</p>
                    <SelectBox :items="chartTypes" v-model="filtersData.chartType" @input="selectChange"></SelectBox>
                </div>

                <div class="filters-chart-type"  v-if="filtersData.chartType === 'revenue' || filtersData.chartType === 'new'">
                    <p class="filter-label">Revenue Type</p>
                    <SelectBox :items="cumulativeTypes" v-model="filtersData.cumulativeType" @input="selectChange"></SelectBox>
                </div>

                <div class="filters-dollar-range" v-if="filtersData.chartType === 'revenue' || filtersData.chartType === 'new'">
                    <p class="filter-label">Top Curves</p>
                        <CurvesIntegerInputBox
                            :startingValue="filtersData.curves ? filtersData.curves.toString() : ''"
                            :isBreakApart="this.filtersData.isBreakApart"
                            v-model="filtersData.curves">
                        </CurvesIntegerInputBox>
                </div>

                <div class="filters-dollar-range" v-if="filtersData.chartType === 'new' || filtersData.chartType === 'revenue'">
                    <p class="filter-label">Dollar Range (MIL)</p>
                    <div class="filters-comboboxes">
                        <RevenueFromToBox
                            :startingValues="(filtersData.revenues)? filtersData.revenues.toString().split(','):[]"
                            :isBreakApart="this.filtersData.isBreakApart"
                            v-model="filtersData.revenues">
                        </RevenueFromToBox>
                    </div>
                </div>

                <div class="filters-dollar-range" v-if="filtersData.chartType === 'new'">
                    <p class="filter-label">Launch Period</p>
                    <div class="filters-comboboxes">
                        <FromToBox v-if="filtersData.chartType === 'new'"
                                   :items="ranges"
                                   v-model="filtersData.range">
                        </FromToBox>
                    </div>
                </div>

                <div class="filters-dollar-range" v-if="filtersData.chartType !== 'growth'">
                    <p class="filter-label">Revenues Period</p>
                    <div class="filters-comboboxes">
                        <FromToBox
                            @changeRevenueFilterRange="selectChange"
                                   :items="revenueFilterRangesComputed"
                                   v-model="filtersData.revenueFilterRange">

                        </FromToBox>
                    </div>
                </div>

                <div class="filters-dollar-range" v-if="filtersData.chartType !== 'growth'">
                    <p class="filter-label">Quarters Period</p>
                    <div class="filters-comboboxes">
                        <QuarterYearBox
                            :key="filterChanged"
                            :items="quarterDataMutable"
                            :selectedItems="filtersData.quarterData"
                            v-model="filtersData.quarterData">
                        </QuarterYearBox>
                    </div>
                </div>

                <div class="filters-dollar-range">
                    <p class="filter-label">Exclude Brands</p>
                    <div class="filters-comboboxes">
                        <ComboBox
                            v-model="filtersData.excludeBrands"
                            :open.sync="open.excludeBrands"
                            :items="excludeBrands"
                            :reset.sync="reset"
                            :filters="filters"
                            noItemsText="All brands"
                            placeholder="Search brands"
                            @toggleActive="toggleActive('excludeBrands', $event)"
                            @update:open="onUpdateOpen('excludeBrands', $event)">
                        </ComboBox>
                    </div>
                </div>

                <div class="filters-fields">
                    <div style="display: flex; flex-direction: column;">
                    <p class="filter-label">Filter by</p>

                    </div>
                    <div class="filters-comboboxes">
                        <ComboBox
                            v-if="filtersData.chartType === 'growth'"
                            v-model="filtersData.growthRates"
                            :open.sync="open.growthRates"
                            :items="growthRates"
                            :reset.sync="reset"
                            :filters="filters"
                            :showSearch="false"
                            noItemsText="All ranges"
                            placeholder="Search growth rates"
                            @toggleActive="toggleActive('growthRates', $event)"
                            @update:open="onUpdateOpen('growthRates', $event)">
                        </ComboBox>
                        <IntegerInputBox
                                v-if="filtersData.chartType === 'growth' && filtersData.growthRates.length===1"
                                v-model="filtersData.growthRatesQuarters"
                                :open.sync="open.growthRatesQuarters"
                                :reset.sync="reset"
                                :filters="filters"
                                noItemsText="Any Quarters"
                                placeholder="Search Quarters Connected Quantity"
                                @toggleActive="toggleActive('growthRatesQuarters', $event)"
                                @update:open="onUpdateOpen('growthRatesQuarters', $event)">
                        </IntegerInputBox>
                        <ComboBox
                            v-model="filtersData.companies"
                            :open.sync="open.companies"
                            :items="companies"
                            :reset.sync="reset"
                            :filters="filters"
                            noItemsText="All companies"
                            placeholder="Search companies"
                            @toggleActive="toggleActive('companies', $event)"
                            @update:open="onUpdateOpen('companies', $event)">
                        </ComboBox>
                        <ComboBox
                            v-model="filtersData.brands"
                            :open.sync="open.brands"
                            :items="brands"
                            :reset.sync="reset"
                            :filters="filters"
                            noItemsText="All brands"
                            placeholder="Search brands"
                            @toggleActive="toggleActive('brands', $event)"
                            @update:open="onUpdateOpen('brands', $event)">
                        </ComboBox>
                        <ComboBox
                            v-model="filtersData.categories"
                            :open.sync="open.categories"
                            :items="categories"
                            :reset.sync="reset"
                            :filters="filters"
                            :isCategories="true"
                            noItemsText="All categories"
                            placeholder="Search categories"
                            @toggleActive="toggleActive('categories', $event)"
                            @update:open="onUpdateOpen('categories', $event)">
                        </ComboBox>
                        <ComboBox
                            v-model="filtersData.tags"
                            :open.sync="open.tags"
                            :items="tags"
                            :reset.sync="reset"
                            :filters="filters"
                            :loader="loader"
                            noItemsText="All Incidents"
                            placeholder="Search Incidents"
                            @toggleActive="toggleActive('tags', $event)"
                            @update:open="onUpdateOpen('tags', $event)">
                        </ComboBox>
                        <ComboBox
                            v-model="filtersData.subcategories"
                            :open.sync="open.subcategories"
                            :items="filteredSubcategories"
                            :reset.sync="reset"
                            :filters="filters"
                            noItemsText="All sub-categories"
                            placeholder="Search sub-categories"
                            @toggleActive="toggleActive('subcategories', $event)"
                            @update:open="onUpdateOpen('subcategories', $event)">
                        </ComboBox>
                        <ComboBox
                            v-model="filtersData.classes"
                            :open.sync="open.classes"
                            :items="classes"
                            :reset.sync="reset"
                            :filters="filters"
                            noItemsText="All classes"
                            placeholder="Search classes"
                            @toggleActive="toggleActive('classes', $event)"
                            @update:open="onUpdateOpen('classes', $event)">
                        </ComboBox>

                    </div>
                </div>
                <div class="filters-settings" >
                    <p class="filter-label">Settings</p>
                    <div class="filters-comboboxes">
                        <CumulativeRevenueToggle v-model="filtersData.showCumulativeRevenueChart"
                                        v-if="filtersData.chartType === 'revenue' || filtersData.chartType === 'new'"
                                         class="cumulative-revenue" style="margin-bottom: 10px"  ></CumulativeRevenueToggle> 
                        <StartSyncViewToggle v-model="filtersData.startSyncView"
                                        v-if="filtersData.chartType === 'revenue' || filtersData.chartType === 'new'"
                                         class="start-sync-view"  ></StartSyncViewToggle>
                    </div>
                </div>
            </div>
        </VueCustomScrollbar>
        <div class="filters-buttons">

            <div class="filters-button">
                <v-btn class="btn reset-filters" @click="resetFilters">Reset Filters</v-btn>
            </div>
            <div class="filters-button">
                <v-btn class="btn btn-primary" @click="applyFilters">{{actionText}}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>

import VueCustomScrollbar from 'vue-custom-scrollbar';

import SelectBox from '../common/SelectBox.vue';
import ComboBox from '../common/ComboBox.vue';

import chartModel from '../../models/chartModel';
import FromToBox from '../common/FromToBox.vue';
import CumulativeRevenueToggle from './Filters/CumulativeRevenueToggle';
import StartSyncViewToggle from './Filters/StartSyncViewToggle';
import RevenueFilterBox from './Filters/RevenueFilterBox.vue';
import RevenueFromToBox from '../common/RevenueFromToBox.vue';
import IntegerInputBox from "../common/IntegerInputBox";
import CurvesIntegerInputBox from "../common/CurvesIntegerInputBox";
import QuarterYearBox from "../common/QuarterYearBox";

export default {
    components: {
        QuarterYearBox,
        CurvesIntegerInputBox,
        IntegerInputBox,
        FromToBox,
        RevenueFromToBox,
        RevenueFilterBox,
        VueCustomScrollbar,
        SelectBox,
        ComboBox,
        CumulativeRevenueToggle,
        StartSyncViewToggle,
    },
    props: {
        filters: {
            type: Object,
        },
        chartTypes: {
            type: Array,
        },
        cumulativeTypes: {
            type: Array,
        },
        growthRates: {
            type: Array,
        },
        growthRatesQuarters: {
            type: Array,
        },
        companies: {
            type: Array,
        },
        categories: {
            type: Array,
        },
        subcategories: {
            type: Array,
        },
        classes: {
            type: Array,
        },
        ranges: {
            type: Array,
        },
        revenueFilterRanges: {
            type: Array,
        },
        revenues: {
            type: Array,
        },
        brands: {
            type: Array,
        },
        excludeBrands: {
            type: Array,
        },
        quarterData: {
            type: Array,
        },
        tags: {
            type: Array,
        },
        curves: {
            type: Array,
        },
        actionText: {
            type: String,
            default: 'Apply Filters'
        },
    },
    computed: {
        filteredSubcategories() {
            this.loader = true;

            const subByCategory = this.subcategories
                .filter(subcategory => !this.filtersData.categories
                    || this.filtersData.categories.length === 0
                    || this.filtersData.categories.indexOf(subcategory.parentId) >= 0);


            if (!this.filtersData.tags || this.filtersData.tags.length === 0) {
                this.loader = false;
                return subByCategory;
            }

            const subByIncidents = [];

            subByCategory.map(subcategory => {
                this.filtersData.tags.map(selectedTag => {
                    const tag = this.tags.find(tag => tag.value === selectedTag);
                    if (tag) {

                        const tagCategories = tag.categories;

                        if (tagCategories && tagCategories.length > 0) {

                            tagCategories.map(catValue => {
                                if (catValue.id === subcategory.value) {
                                    subByIncidents.push(subcategory)
                                }
                            })
                        }
                    }
                });
            });

            this.loader = false;
            return subByIncidents;
        },
        revenueFilterRangesComputed(){
            if(!this.filtersData.range)
                return this.revenueFilterRanges;
            const rangeData = this.filtersData.range.split(',');
            const rangeFromYear = parseInt(rangeData[0],10);
            const rangeToYear = parseInt(rangeData[1],10);
            return this.revenueFilterRanges.filter((e) => parseInt(e.value,10) >= rangeFromYear && parseInt(e.value,10) <= rangeToYear );
        }
    },
    watch: {
        filters() {
            this.getFilters();
        },
        'filtersData.chartType'(newValue) {
            if(newValue == 'growth'){
                this.filtersData.showCumulativeRevenueChart = false;
                this.filtersData.startSyncView = false;
            } 
        },
        'filtersData.startSyncView'(newValue) {
            if(newValue) this.filtersData.showCumulativeRevenueChart=false;
        },
        'filtersData.showCumulativeRevenueChart'(newValue) {
            if(newValue) this.filtersData.startSyncView=false;
        },
        'filtersData.range'(newValue) {
            if(!newValue || !this.filtersData.revenueFilterRange) return;
            const rangeData = newValue.split(',');
            const revenueFilterRangeData = this.filtersData.revenueFilterRange.split(',');

            const rangeFromYear = parseInt(rangeData[0],10);
            const rangeToYear = parseInt(rangeData[1],10);

            const revenueFilterRangeFromYear = parseInt(revenueFilterRangeData[0],10);
            const revenueFilterRangeToYear = parseInt(revenueFilterRangeData[1],10);
            
            const newRevenueFilterRangeFromYear = rangeFromYear>revenueFilterRangeFromYear ? rangeFromYear : revenueFilterRangeFromYear;
            const newRevenueFilterRangeToYear = rangeToYear<revenueFilterRangeToYear || revenueFilterRangeToYear<rangeFromYear ? rangeToYear : revenueFilterRangeToYear;

            this.filtersData.revenueFilterRange = newRevenueFilterRangeFromYear.toString() + ',' + newRevenueFilterRangeToYear.toString();
        },
    },
    data() {
        return {
            filtersData: {},
            filterChanged: false,
            quarterDataMutable: this.quarterData,
            isActive: {
                growthRates: true,
                growthRatesQuarters: true,
                companies: true,
                categories: true,
                subcategories: true,
                classes: true,
                brands: true,
                curves: true,
                excludeBrands: true,
                tags: true,
                revenues_filter: true,
                showCumulativeRevenueChart: true,
                startSyncView: false,
                cumulativeType: true,
                quarterData: true,
            },
            open: {
                growthRates: false,
                growthRatesQuarters: false,
                companies: false,
                categories: false,
                subcategories: false,
                classes: false,
                brands: false,
                curves: false,
                excludeBrands: false,
                tags: false,
                revenues_filter: false,
                showCumulativeRevenueChart: true,
                startSyncView: false,
                cumulativeType: true,
                quarterData: true,
            },
            reset: false,
            loader: false,
        };
    },
    mounted() {
        this.getFilters();
    },
    methods: {
        selectChange(){
            this.quarterDataMutable = this.filtersData.revenueFilterRange;
            this.filtersData.growthRates=[];
            this.filtersData.growthRatesQuarters=[];
            this.filterChanged = !this.filterChanged;
        },
        getFilters() {
            this.filtersData = JSON.parse(JSON.stringify(this.filters));
            this.filtersData.showCumulativeRevenueChart = (this.filters.showCumulativeRevenueChart!==undefined)?this.filters.showCumulativeRevenueChart:true;            
            this.filtersData.startSyncView = (this.filters.startSyncView!==undefined)?this.filters.startSyncView:false;
            this.filtersData.cumulativeType = (this.filters.cumulativeType!==undefined && this.filters.cumulativeType!==null && this.filters.cumulativeType!=='')?this.filters.cumulativeType:'none';
            this.filtersData.range = (this.filters.range!==undefined && this.filters.range!==null) ?this.filters.range.toString():'';
            this.filtersData.revenueFilterRange = (this.filters.revenueFilterRange!==undefined && this.filters.revenueFilterRange!==null) ?this.filters.revenueFilterRange.toString():'';
            this.filtersData.quarterData = (this.filters.quarterData!==undefined && this.filters.quarterData!==null) ?this.filters.quarterData.toString():'';

            const isBreakApart = this.filtersData.breakApart;

            if (isBreakApart) {
                this.filtersData.chartType = this.filtersData.parentChartType;
            }
        },
        closeFilters(event) {
            if (event) {
                event.preventDefault();
            }

            this.$store.commit('chart/toggleFilters', false);
        },
        resetFilters() {
            const modelFilters = JSON.parse(JSON.stringify(chartModel.filters));
            this.filtersData = {
                open: this.filtersData.open,
                chartType: this.filters.chartType,
                cumulativeType: 'none',
                range: modelFilters.range,
                revenueFilterRange: modelFilters.revenueFilterRange,
                revenues: modelFilters.revenues,
                curves: modelFilters.curves,
                growthRates: [],
                growthRatesQuarters: [],
                companies: [],
                categories: [],
                subcategories: [],
                classes: [],
                brands: [],
                excludeBrands: [],
                quarterData: modelFilters.quarterData.toString(),
                tags: [],
                showCumulativeRevenueChart: modelFilters.showCumulativeRevenueChart,
                startSyncView: modelFilters.startSyncView,
            };
            this.reset = !this.reset;
        },
        toggleActive(type, isActive) {
            this.isActive[type] = isActive;
            switch (type) {
                case 'categories':
                    this.filtersData.categories = null;
                    break;
                case 'tags':
                    this.filtersData.tags = null;
                    break;
                default:
                    return;
            }
        },
        onUpdateOpen(type, value) {
            if (value) {
                this.open[type] = value;

                Object.keys(this.open).forEach((openKey) => {
                    if (openKey !== type) {
                        this.open[openKey] = !value;
                    }
                });
            }
        },
        applyFilters() {
            const { isActive, filtersData } = this;
            const modelFilters = JSON.parse(JSON.stringify(chartModel.filters));

            this.$emit('apply', Object.assign({}, this.filtersData, {
                growthRates: isActive.growthRates ? filtersData.growthRates : modelFilters.growthRates,
                growthRatesQuarters: isActive.growthRatesQuarters ? filtersData.growthRatesQuarters : modelFilters.growthRatesQuarters,
                companies: isActive.companies ? filtersData.companies : modelFilters.companies,
                categories: isActive.categories ? filtersData.categories : modelFilters.categories,
                subcategories: isActive.subcategories ? filtersData.subcategories : modelFilters.subcategories,
                classes: isActive.classes ? filtersData.classes : modelFilters.classes,
                brands: isActive.brands ? filtersData.brands : modelFilters.brands,
                excludeBrands: isActive.excludeBrands ? filtersData.excludeBrands : modelFilters.excludeBrands,
                quarterData: isActive.quarterData ? filtersData.quarterData : modelFilters.quarterData,
                tags: isActive.tags ? filtersData.tags : modelFilters.tags,
                revenueFilterRange: isActive.revenues_filter ? filtersData.revenueFilterRange : modelFilters.revenueFilterRange,
                showCumulativeRevenueChart: filtersData.showCumulativeRevenueChart,
                startSyncView: filtersData.startSyncView,
                cumulativeType: filtersData.cumulativeType,
            }));
        },
    },
};

</script>

<style lang="scss">
    @import '../../style/Charts/FiltersComponent.scss';
</style>
